export default __webpack_public_path__ + "static/media/immutable.91e5d55f.svg";